import { render, staticRenderFns } from "./Singular.vue?vue&type=template&id=afc0243a&scoped=true"
import script from "./Singular.vue?vue&type=script&lang=js"
export * from "./Singular.vue?vue&type=script&lang=js"
import style0 from "./Singular.vue?vue&type=style&index=0&id=afc0243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc0243a",
  null
  
)

export default component.exports